import { useEffect, useState } from "react";
import { fetchCached } from "@/lib/userCache";

/**
 * TitleTag — renders the user's highest-rank title next to their name.
 * V2.5.2 — cached so 50-row leaderboards reuse the same per-user response.
 */
export default function TitleTag({ userId, size = "sm", className = "" }) {
  const [title, setTitle] = useState(null);

  useEffect(() => {
    if (!userId) return;
    let cancelled = false;
    fetchCached("achievements", `/achievements/user/${userId}`).then(data => {
      if (cancelled) return;
      setTitle(data.current_title || null);
    }).catch(() => {});
    return () => { cancelled = true; };
  }, [userId]);

  if (!title) return null;
  const px = size === "lg" ? "text-[11px] px-2 py-0.5" : size === "md" ? "text-[10px] px-1.5 py-0.5" : "text-[9px] px-1.5 py-[1px]";
  return (
    <span
      data-testid={`title-tag-${userId}`}
      title={`${title.name} (${title.letter}-Rank)`}
      className={`inline-flex items-center rounded font-black uppercase tracking-wider border ${px} ${className}`}
      style={{
        color: title.color,
        borderColor: `${title.color}66`,
        background: `${title.color}1a`,
      }}>
      {title.name}
    </span>
  );
}
